import React, { Fragment } from 'react'
import { FormattedMessage } from '@dragonraider5/react-intl'
import get from 'lodash/fp/get'

import { showFieldError, renderValidation } from '../../../../../utils/validations'
import TextField from '../../../../../components/FormFields/TextField'
import DateField from '../../../../../components/FormFields/DateField/DateField'
import solicitudeMessages from '../../Project/Forms/valueMessages'
import { FINANCIAL_TYPES_VALUES, FINANCINGS_WITH_SHARE } from '../../constants'
import SelectField from '../../../../../components/FormFields/SelectField'

const makeOnNumberValueChange = (name, { setFieldValue }) =>
  values => setFieldValue(name, values.floatValue)

function FinancialFormFields({
  values,
  errors,
  touched,
  setFieldValue,
  handleChange,
  handleBlur,
  namePrefix=''
}) {
  const financingTypeName = `${namePrefix}financing_type`
  const amountName = `${namePrefix}amount`
  const interestRateName = `${namePrefix}interest_rate`
  const entityName = `${namePrefix}entity`
  const expirationName = `${namePrefix}expiration`
  const shareName = `${namePrefix}share`


  const handleChangeFinancingType = (e) => {
    const val = e.target.value
    if (!val) return ''
    setFieldValue(financingTypeName, Number(val))
    
    if (!FINANCINGS_WITH_SHARE.includes(Number(val)) && !isNaN(get(shareName)(values))) {
      setFieldValue(shareName, null)
    }
  }

  return (
    <Fragment>
      <SelectField
        name={financingTypeName}
        value={get(financingTypeName)(values)}
        onChange={handleChangeFinancingType}
        onBlur={handleBlur}
        error={showFieldError(financingTypeName, { errors, touched })}
        help={renderValidation(financingTypeName, { errors, touched })}
        label='Tipo de financiación'
        full
      >
        <option value='' />
        {Object.values(FINANCIAL_TYPES_VALUES).map(value => (
          <FormattedMessage key={value} {...solicitudeMessages[`financialTypes${value}`]}>
            {message => <option value={value}>{message}</option>}
          </FormattedMessage>
        ))}
      </SelectField>
      <TextField
        type='numeric'
        name={amountName}
        value={get(amountName)(values)}
        onValueChange={makeOnNumberValueChange(amountName, { setFieldValue })}
        onBlur={handleBlur}
        error={showFieldError(amountName, { errors, touched })}
        help={renderValidation(amountName, { errors, touched })}
        label='Importe'
        suffix='€'
        thousandSeparator='.'
        decimalSeparator=','
        allowNegative={false}
        full
      />
      <TextField
        type='numeric'
        name={interestRateName}
        value={get(interestRateName)(values)}
        onValueChange={makeOnNumberValueChange(interestRateName, { setFieldValue })}
        onBlur={handleBlur}
        error={showFieldError(interestRateName, { errors, touched })}
        help={renderValidation(interestRateName, { errors, touched })}
        label='Tipo de interés'
        suffix='%'
        thousandSeparator='.'
        decimalSeparator=','
        allowNegative={false}
        full
      />
      <TextField
        type='text'
        name={entityName}
        value={get(entityName)(values)}
        onChange={handleChange}
        onBlur={handleBlur}
        error={showFieldError(entityName, { errors, touched })}
        help={renderValidation(entityName, { errors, touched })}
        label='Entidad financiera'
        full
      />
      <DateField 
        name={expirationName}
        value={get(expirationName)(values)}
        onChange={handleChange}
        onBlur={handleBlur}
        error={showFieldError(expirationName, { errors, touched })}
        help={renderValidation(expirationName, { errors, touched })}
        label='Vencimiento'
        shrinkLabel
        full
      />
      {FINANCINGS_WITH_SHARE.includes(get(financingTypeName)(values)) &&
        <TextField
          type='numeric'
          name={shareName}
          value={get(shareName)(values)}
          onValueChange={makeOnNumberValueChange(shareName, { setFieldValue })}
          onBlur={handleBlur}
          error={showFieldError(shareName, { errors, touched })}
          help={renderValidation(shareName, { errors, touched })}
          label='Cuota'
          suffix='€'
          thousandSeparator='.'
          decimalSeparator=','
          allowNegative={false}
          full
        />
      }
    </Fragment>
  )
}

export default FinancialFormFields
